import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AsideService {
  private openModalSubject = new Subject<any>();
  openModalSubject$ = this.openModalSubject.asObservable();

  private insideExamenSubject = new BehaviorSubject<any>(false);
  insideExamenSubject$ = this.insideExamenSubject.asObservable();

  constructor() { }

  openModal(event: any): void {
    this.openModalSubject.next(event);
  }

  setInsideExamen(event: any): void {
    this.insideExamenSubject.next(event);
  }
}
